import { useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";

import api from "../../api/api";
import { currencyFormat, getCaseId, getClientId } from "../../Utils/helper";

import { useCheckRequestModal } from "./CheckRequestModalContext";
import { useUpdateTrigger } from "./TriggerUpdateContext"; // Import the useModal hook

const CheckRequestModal = () => {
  const { isVisible, modalData, hideModal } = useCheckRequestModal();
  const { toggleTriggerUpdate } = useUpdateTrigger();
  const [errorMessage, setErrorMessage] = useState("");
  const confirmCostCheckRequest = async (clientId, caseId, costId) => {
    try {
      const response = await api.post(
        `api/check-request/${getClientId()}/${getCaseId()}/costs/${costId}/`
      );
      if (!response.status.toString().startsWith("2")) {
        let errorMessage = "Check request failed";
        try {
          const errorData = await response.data;
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch (error) {
          console.error("Error parsing API error response:", error);
        }
        setErrorMessage(errorMessage);
        return;
      }

      setErrorMessage("");
      toggleTriggerUpdate();
      hideModal(); // Close modal on success
    } catch (error) {
      setErrorMessage(error.message || "An unknown error occurred");
    }
  };
  return (
    <Modal
      dialogClassName=" modal-dialog-centered "
      contentClassName="custom-modal-new-provider"
      show={isVisible}
      onHide={hideModal}
      centered
    >
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Confirm Check Request
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          padding: "10px",
        }}
      >
        {errorMessage ? <Alert variant="danger">Error creating a check.</Alert> : <></>}
        <div
          className="d-flex align-items-center m-b-5"
          style={{
            gap: "5px",
          }}
        >
          <p
            style={{
              color: "var(--primary-25)",
              fontWeight: "600",
            }}
          >
            Payee:
          </p>
          <span>{modalData.payee}</span>
        </div>
        <div
          className="d-flex align-items-center m-b-5"
          style={{
            gap: "5px",
          }}
        >
          <p
            style={{
              color: "var(--primary-25)",
              fontWeight: "600",
            }}
          >
            Amount:
          </p>
          <span>{currencyFormat(modalData.amount)}</span>
        </div>
        <div
          className="d-flex align-items-center m-b-5"
          style={{
            gap: "5px",
          }}
        >
          <p
            style={{
              color: "var(--primary-25)",
              fontWeight: "600",
            }}
          >
            Memo:
          </p>
          <span>{modalData.memo}</span>
        </div>
        <div
          className="d-flex align-items-center m-b-5"
          style={{
            gap: "5px",
          }}
        >
          <p
            style={{
              color: "var(--primary-25)",
              fontWeight: "600",
            }}
          >
            Invoice Number:
          </p>
          <span>{modalData.invoice_number}</span>
        </div>
        <div>Do you want to confirm the check request?</div>
      </Modal.Body>
      <Modal.Footer
        className="p-0 mt-0 padding-outside-btn-new-provider"
        style={{ borderTop: "none" }}
      >
        <Button
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
          variant="secondary"
          onClick={hideModal}
        >
          Cancel
        </Button>
        <Button
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
          variant="primary"
          onClick={async () => {
            await confirmCostCheckRequest(modalData.clientId, modalData.caseId, modalData.costId);
            hideModal();
          }}
        >
          Request
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckRequestModal;
